import { NgModule } from '@angular/core';
import { SanitizeSrcService } from './sanitizesrc.pie';


@NgModule({
    imports: [

    ],

    declarations: [
        SanitizeSrcService
    ],

    exports: [
        SanitizeSrcService
    ],

    providers: [
        SanitizeSrcService
    ]
})
export class SanitizeSrcServiceModule { }